e4.parallax = {
    init: function () {
        e4.parallax.isRAF = false;
        e4.parallax.loadImages();
        if(jQuery(window).width() > 768){
            e4.parallax.bindEvents();
            e4.parallax.animate();
        }
    },
    loadImages: function () {
        jQuery( '.js-p-img-parallax' ).each( function () {
            jQuery( this ).attr( 'src', this.getAttribute( 'data-src' ) );
        } );
        jQuery( '.js-p-img-parallax' ).on( 'load', function () {
            jQuery( this ).addClass( 'is-loaded' );
        } );
    },
    bindEvents: function () {
        jQuery( window ).on( 'scroll resize', function () {
            if ( e4.parallax.isRAF === false ) {
                window.requestAnimationFrame( function () {
                    e4.parallax.animate();
                    e4.parallax.isRAF = false;
                } );
                e4.parallax.isRAF = true;
            }
        } );
    },
    animate: function () {
        var windowScrollTop = jQuery( window ).scrollTop();
        jQuery( '.js-p-img-parallax' ).each( function () {
            var jThis = jQuery( this );
            if ( e4.util.isInViewport( jThis ) === true ) {
                var translateY = Math.round( ( jThis.parent().offset().top - windowScrollTop ) * e4.settings.parallax.speed );
                jThis.css( {
                    'transform': 'translateY(' + translateY + 'px)'
                } );
            }
        } );
    }
};